<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
// import Datatable from "@/router/layouts/table-datatable.vue";
// import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import { ref } from "vue";

export default {
    page: {
        title: "Detail Dokumentasi",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: {
        Layout,
        PageHeader,
    },
    data() {

        return {
            title: "Detail Data Dokumentasi",
            items: [
                {
                    text: "Dokumentasi",
                    href: "/dokumentasi",
                },
                {
                    text: "Detail Data Dokumentasi",
                    active: true,
                },
            ],

            user_role: localStorage.getItem("session_role_active_id"),

            app_url: process.env.VUE_APP_URL,
            id: this.$route.params.id,
            nomor_surat: null,
            kode: null,
            judul: null,
            dasar_pelaksanaan: null,
            strategi: null,
            strategi_id: null,
            durasi_he: null,
            pbl_online: null,
            pbl_offline: null,
            durasi_jp: null,
            tanggal_mulai: null,
            tanggal_selesai: null,
            tanggal_hari_ini: moment(ref(new Date())).format("YYYY-MM-DD"),
            learning_type: null,
            angkatan: null,
            strategi_model: null,

            status_submit: null,
            status_materi: null,
            status_akomodasi: null,
            status_kehadiran: null,
            status_instruktur: null,
            status_laporan: null,
            status_absensi_peserta: false,
            pembelajaran_status_peserta: null,
            pembelajaran_status_peserta_lms: null,
            status_button_verif_all_peserta: false,

            akomodasi_generate_at: null,
            feedback_peserta: null,
            feedback_peserta_temp: null,
            tot_budget_plan: null,
            tot_budget_confirm: null,
            tot_budget_fix: null,

            multipleSend: [],
            instrukturDuplikat: [],
            akomodasiDuplikat: [],
            materiDuplikat: [],
            praktikumDuplikat: [],
            idMateri: null,

            peserta_pembelajaran: [],
            link_wa_grup: null,
            pembelajaran_kelas: null,
            jumlah_peserta_bersedia: null,
            jumlah_peserta_tidak_bersedia: null,
            status_konfirmasi_panitia: false,
            status_unggah_undangan: "peserta",
            tipeSuratPemanggilan: 1,

            pratikum: null,
            pratikum_data: null,

            pic: null,

            idPraktikumSelected: null,

            showFormEditMateri: false,
            showFormUnggahUndangan: false,
            showFormDetailPraktikum: false,
            showTableInstruktur: true,
            showTableMateri: true,
            showTablePraktikum: true,
            showTableAkomodasi: true,
            showDetailPraktikum: false,
            showFormAbsensiPeserta: false,
            showFormAbsensiInstruktur: false,
            showFeedbackPeserta: false,
            showKamar: false,
            showFormKamar: false,
            showFormTemplateSurat: false,
            showTableDiklat: false,

            selectStageAdd: '',
            currentStagesValueAdd: '',

            // mkp_idAdd: "",
            titleMateriAdd: "",
            dateAgendaAdd: "",
            durationAgendaAdd: "",
            durationStartAdd: "",
            durationEndAdd: "",
            selectInstrukturAdd: "",
            detailAgendaAdd: "",
            selectGroupAdd: "",
            linkAgendaAdd: "",
            linkFileAdd: "",
            linkVideoAdd: "",
            questionUploadAdd: "",

            // config untuk paginasi
            pagination: {
                lastPage: "",
                currentPage: "",
                total: "",
                lastPageUrl: "",
                nextPageUrl: "",
                prevPageUrl: "",
                from: "",
                to: "",
                links: "",
            },

            showModal: {
                upload: false,
            },
            loadingTable: {
                dokumentasiFoto: true,
                dokumentasiNotulensi:true,
                dokumentasiPersepsi:true,
            },
            dataTableDokumentasiFoto: [],
            dataTableDokumentasiNotulensi:[],
            dataTableDokumentasiPersepsi:[]
        };
    },
    mounted() {
        let self = this;
        Swal.fire({
            title: '<i class="fas fa-spinner fa-spin"></i>',
            text: "Loading...",
            showConfirmButton: false,
            allowOutsideClick: false,

        });

        // get data pembelajaran
        var config = {
            method: "get",
            url:
                process.env.VUE_APP_BACKEND_URL_VERSION + "transactions/pembelajaran",
            params: {
                id: self.id,
            },
            headers: {
                Accept: "application/json",
                Authorization: "Bearer " + localStorage.access_token,
            },
        };
        axios(config)
            .then(function (response) {
                var response_data = response.data;
                var response_data_fix = response_data.data;
                if (response_data.meta.code == 200) {
                    var data_edit = response_data_fix.data_pembelajaran;
                    self.nomor_surat = data_edit.pbl_nomor_surat;
                    self.kode = data_edit.pbl_kode;
                    self.judul = data_edit.pbl_dasar_pelaksanaan;
                    self.dasar_pelaksanaan = data_edit.pbl_judul;
                    self.strategi = data_edit.pbl_strategi;
                    self.strategi_id = data_edit.pbl_strategi_id;
                    self.durasi_he = data_edit.pbl_durasi_he;
                    self.pbl_online = data_edit.pbl_he_online;
                    self.pbl_offline = data_edit.pbl_he_offline;
                    self.durasi_jp = data_edit.pbl_durasi_jp;
                    self.tanggal_mulai = data_edit.pbl_tgl_mulai;
                    self.tanggal_selesai = data_edit.pbl_tgl_selesai;
                    self.learning_type = data_edit.pbl_lt_name;
                    self.angkatan = data_edit.pbl_angkatan;
                    self.status_submit = data_edit.status_perencanaan;
                    self.status_materi = data_edit.status_materi;
                    self.status_akomodasi = data_edit.status_akomodasi;
                    self.status_kehadiran = data_edit.status_kehadiran;
                    self.status_instruktur = data_edit.status_instruktur;
                    self.status_laporan = data_edit.status_laporan;
                    self.pembelajaran_status_peserta = data_edit.status_peserta;
                    self.pembelajaran_status_peserta_lms = data_edit.status_peserta_lms;
                    self.akomodasi_generate_at = data_edit.pbl_generate_akomodasi_at;
                    self.tot_budget_plan = data_edit.pbl_tot_budget_plan;
                    self.tot_budget_confirm = data_edit.pbl_tot_budget_confirm;
                    self.tot_budget_fix = data_edit.pbl_tot_budget_fix;

                    self.showTableDiklat = true;

                    self.strategi_model = data_edit.strategi.ms_model;
                    self.feedback_peserta = data_edit.strategi.pbl_feedback;

                    self.peserta_pembelajaran = data_edit.pembelajaran_peserta;
                    self.link_wa_grup = data_edit.pbl_link_wa_grup;
                    self.pembelajaran_kelas = data_edit.pbl_kelas;
                    self.jumlah_peserta_bersedia =
                        response_data_fix.jumlah_peserta_bersedia;
                    self.jumlah_peserta_tidak_bersedia =
                        response_data_fix.jumlah_peserta_tidak_bersedia;
                    self.status_konfirmasi_panitia =
                        response_data_fix.status_konfirmasi_panitia;

                    self.pratikum = data_edit.pbl_pratikum;
                    if (data_edit.pembelajaran_pratikum != null) {
                        self.pratikum_data = data_edit.pembelajaran_pratikum;
                    }

                    if (data_edit.pic != null) {
                        self.pic =
                            `(${data_edit.pic.mp_kategori}) ` +
                            data_edit.pic.user.username +
                            " - " +
                            data_edit.pic.user.name;
                    }

                    if (self.tanggal_hari_ini >= data_edit.pbl_tgl_mulai) {
                        self.status_absensi_peserta = true;
                    } else {
                        self.status_absensi_peserta = false;
                    }
                    self.status_button_verif_all_peserta =
                        response_data_fix.status_button_verif_all;

                    self.showTableAkomodasi = false;
                    self.$nextTick(() => {
                        self.showTableAkomodasi = true;
                    });
                    Swal.close();
                } else {
                    Swal.close();
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: response_data_fix.data.message,
                    });
                }
            })
            .catch(function (error) {
                console.log(error);
                Swal.close();
            });
        self.getDataDokumentasiFoto();
        self.getDataDokumentasiNotulensi();
        self.getDataDokumentasiPersepsi();

    },
    methods: {
        showModalUpload() {
            let self = this;

            self.showModal.upload = true;
        },
        getDataDokumentasiFoto() {
            let self = this;
            self.loadingTable.dokumentasiFoto = true;

            var config = {
                method: 'get',
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/kode-pembelajaran/dokumentasi",
                params:{
                    kategori: 'KATEGORI_DOKUMENTASI_Foto Kegiatan'
                },
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token
                }
            }

            axios(config).then((response) => {
                var resStatus = response.status;

                if (resStatus === 200) {
                    var resData = response.data.data[0];

                    self.loadingTable.dokumentasiFoto = false;
                    self.dataTableDokumentasiFoto = resData;
    
                }
                
            }).catch((error) => {
                self.loadingTable.dokumentasiFoto = false;
                console.log(error);
            });
        },
        getDataDokumentasiNotulensi() {
            let self = this;
            self.loadingTable.dokumentasiNotulensi = true;

            var config = {
                method: 'get',
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/kode-pembelajaran/dokumentasi",
                params:{
                    kategori: 'KATEGORI_DOKUMENTASI_Notulen Rapat'
                },
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token
                }
            }

            axios(config).then((response) => {
                var resStatus = response.status;

                if (resStatus === 200) {
                    var resData = response.data.data[0];

                    self.loadingTable.dokumentasiNotulensi = false;
                    self.dataTableDokumentasiNotulensi = resData;
    
                }
                
            }).catch((error) => {
                self.loadingTable.dokumentasiNotulensi = false;
                console.log(error);
            });
        },
        getDataDokumentasiPersepsi() {
            let self = this;
            self.loadingTable.dokumentasiPersepsi = true;

            var config = {
                method: 'get',
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/kode-pembelajaran/dokumentasi",
                params:{
                    kategori: 'KATEGORI_DOKUMENTASI_Persamaan Persepsi'
                },
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token
                }
            }

            axios(config).then((response) => {
                var resStatus = response.status;

                if (resStatus === 200) {
                    var resData = response.data.data[0];

                    self.loadingTable.dokumentasiPersepsi = false;
                    self.dataTableDokumentasiPersepsi = resData;
    
                }
                
            }).catch((error) => {
                self.loadingTable.dokumentasiPersepsi = false;
                console.log(error);
            });
        },
        downloadFile(pathFile){
            var fileDownload = process.env.VUE_APP_BACKEND_URL + pathFile;

            window.open(fileDownload, '_blank');

        }
    },
  
};
</script>
<style>
button.nav-link {
    padding: 0 !important;
}

li.nav-item .customTab {
    padding: 8px 10px;
}
</style>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-lg-12">
                <div class="row">
                    <div class="col-12 text-end mb-3">
                        <router-link :to="{ name: 'all-evaluasi' }" class="btn btn-danger"><i class="fa fa-arrow-left"></i> <b>Kembali</b></router-link>
                    </div>
                </div>

                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12">
                                <b-card header-class="bg-transparent border-primary" class="border border-primary">
                                    <template v-slot:header>
                                        <h5 class="my-0 text-primary">
                                            <i class="mdi mdi-calendar-edit me-3"></i>
                                            <span>Formulir Dokumentasi</span>
                                        </h5>
                                    </template>
                                    <div class="card-body p-0">
                                        <div class="row">
                                            <div class="col-3">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <h5 class="font-size-12">
                                                            <span class="text-dark">Nomor Surat</span>
                                                        </h5>
                                                        <p class="text-muted mb-0 font-size-11">{{ nomor_surat }}</p>
                                                        <hr style="margin:0 !important;">
                                                    </div>
                                                    <div class="col-12">
                                                        <h5 class="font-size-12">
                                                            <span class="text-dark">Kode Pembelajaran</span>
                                                        </h5>
                                                        <p class="text-muted mb-0 font-size-11">{{ kode }}</p>
                                                        <hr style="margin:0 !important;">
                                                    </div>
                                                    <div class="col-12">
                                                        <h5 class="font-size-12">
                                                            <span class="text-dark">Dasar Pelaksanaan</span>
                                                        </h5>
                                                        <p class="text-muted mb-0 font-size-11">
                                                            {{ dasar_pelaksanaan }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-3">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <h5 class="font-size-12">
                                                            <span class="text-dark">Judul Pembelajaran</span>
                                                        </h5>
                                                        <p class="text-muted mb-0 font-size-11">{{ judul }}</p>
                                                        <hr style="margin:0 !important;">
                                                    </div>
                                                    <div class="col-12">
                                                        <h5 class="font-size-12">
                                                            <span class="text-dark">Strategi</span>
                                                        </h5>
                                                        <p class="text-muted mb-0 font-size-11">{{ strategi }}</p>
                                                        <hr style="margin:0 !important;">
                                                    </div>
                                                    <div class="col-12">
                                                        <h5 class="font-size-12">
                                                            <span class="text-dark">Tipe Pembelajaran</span>
                                                        </h5>
                                                        <p class="text-muted mb-0 font-size-11">{{ learning_type }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-3">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <h5 class="font-size-12">
                                                            <span class="text-dark">PIC</span>
                                                        </h5>
                                                        <p class="text-muted mb-0 font-size-11">{{ pic }}</p>
                                                        <hr style="margin:0 !important;">
                                                    </div>
                                                    <div class="col-12">
                                                        <h5 class="font-size-12">
                                                            <span class="text-dark">Angkatan</span>
                                                        </h5>
                                                        <p class="text-muted mb-0 font-size-11">{{ angkatan }}</p>
                                                        <hr style="margin:0 !important;">
                                                    </div>
                                                    <div class="col-12">
                                                        <h5 class="font-size-12">
                                                            <span class="text-dark">Pratikum</span>
                                                        </h5>
                                                        <p class="text-muted mb-0 font-size-11">{{ pratikum }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-3">
                                                <div class="col-12">
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <h5 class="font-size-12 mb-1">
                                                                <span class="text-dark">Durasi Hari Efektif (HE)</span>
                                                            </h5>
                                                            <p class="text-muted mb-0 font-size-11">{{ durasi_he }}</p>
                                                            <hr style="margin:0 !important;">
                                                        </div>
                                                        <div class="col-12">
                                                            <h5 class="font-size-12 mb-1">
                                                                <span class="text-dark">Durasi Jam Pembelajaran (JP)</span>
                                                            </h5>
                                                            <p class="text-muted mb-0 font-size-11">{{ durasi_jp }}</p>
                                                            <hr style="margin:0 !important;">
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-12">
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <h5 class="font-size-12 mb-1">
                                                                <span class="text-dark">Tanggal Mulai</span>
                                                            </h5>
                                                            <p class="text-muted mb-0 font-size-11">
                                                                {{ tanggal_mulai }}
                                                            </p>
                                                            <hr style="margin:0 !important;">
                                                        </div>
                                                        <div class="col-12">
                                                            <h5 class="font-size-12 font-size-12">
                                                                <span class="text-dark">Tanggal Selesai</span>
                                                            </h5>
                                                            <p class="text-muted mb-0 font-size-11">
                                                                {{ tanggal_selesai }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-card>
                            </div>
                            <div class="col-12">
                                <b-card header-class="bg-transparent border-primary" class="border border-primary">
                                    <div class="card-body p-0">
                                        <b-tabs pills justified content-class="p-3 text-muted">
                                            <b-tab active>
                                                <template v-slot:title>
                                                    <div class="customTab">Dokumentasi Foto Kegiatan</div>
                                                </template>

                                                <div class="row">
                                                    <div class="col-12">
                                                        <div class="card-title">Dokumentasi Foto Kegiatan</div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <!-- content tab -->
                                                        <div class="row">
                                                            <div class="col-12">
                                                                <div class="card">
                                                                    <div class="card-body">
                                                                        <!-- COntent -->

                                                                        <table class="table table-bordered table-condensed">
                                                                            <thead class="table-danger">
                                                                                <tr class="align-middle text-center">
                                                                                    <th style="width: 75px;"><b>No</b></th>
                                                                                    <th><b>Judul Dokumen</b></th>
                                                                                    <th><b>Link Dokumen</b></th>
                                                                                    <th><b>Deskripsi</b></th>
                                                                                    <th><b>Download file</b></th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <tr v-if="loadingTable.dokumentasiFoto == true">
                                                                                    <td colspan="30" class="text-center">
                                                                                        <i class="fas fa-spin fa-spinner"></i> loading.....
                                                                                    </td>
                                                                                </tr>
                                                                                <tr v-else-if="dataTableDokumentasiFoto == ''">
                                                                                    --- Data Kosong ---
                                                                                </tr>
                                                                                <tr v-else v-for="(rowData, keyData) in dataTableDokumentasiFoto" :key="keyData">
                                                                                    <td class="text-center">{{ keyData + 1 }}</td>
                                                                                    <td>{{ rowData.lm_name }}</td>
                                                                                    <td>{{ rowData.lm_link }}</td>
                                                                                    <td style="text-align: center;">{{  rowData.lm_description }}</td>
                                                                                    <td class="text-center">
                                                                                        <b-button variant="primary" size="sm" @click = "downloadFile(rowData.materi_pembelajaran_dokumen.lmd_path_file)">
                                                                                            <i class="fas fa-download"></i>
                                                                                            &nbsp;
                                                                                            <span>Download</span>
                                                                                        </b-button>
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-tab>
                                            <b-tab>
                                                <template v-slot:title>
                                                    <div class="customTab">Dokumentasi Notulen Rapat</div>
                                                </template>

                                                <div class="row">
                                                    <div class="col-12">
                                                        <div class="card-title">Dokumentasi Notulen Rapat</div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <!-- Content -->
                                                        <table class="table table-bordered table-condensed">
                                                            <thead class="table-danger">
                                                                <tr class="align-middle text-center">
                                                                    <th style="width: 75px;"><b>No</b></th>
                                                                    <th><b>Judul Dokumen</b></th>
                                                                    <th><b>Link Dokumen</b></th>
                                                                    <th><b>Deskripsi</b></th>
                                                                    <th><b>Download file</b></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-if="loadingTable.dokumentasiNotulensi == true">
                                                                    <td colspan="30" class="text-center">
                                                                        <i class="fas fa-spin fa-spinner"></i> loading.....
                                                                    </td>
                                                                </tr>
                                                                <tr v-else-if="dataTableDokumentasiNotulensi == ''">
                                                                    --- Data Kosong ---
                                                                </tr>
                                                                <tr v-else v-for="(rowData, keyData) in dataTableDokumentasiNotulensi" :key="keyData">
                                                                    <td class="text-center">{{ keyData + 1 }}</td>
                                                                    <td>{{ rowData.lm_name }}</td>
                                                                    <td>{{ rowData.lm_link }}</td>
                                                                    <td style="text-align: center;">{{  rowData.lm_description }}</td>
                                                                    <td class="text-center">
                                                                        <b-button variant="primary" size="sm" @click = "downloadFile(rowData.materi_pembelajaran_dokumen.lmd_path_file)">
                                                                            <i class="fas fa-download"></i>
                                                                            &nbsp;
                                                                            <span>Download</span>
                                                                        </b-button>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </b-tab>
                                            <b-tab>
                                                <template v-slot:title>
                                                    <div class="customTab">Dokumentasi Persamaan Persepsi</div>
                                                </template>

                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <!-- content tab -->
                                                        <h4 class="card-title mb-3">Dokumentasi Persamaan Persepsi</h4>

                                                        <div class="card-body p-0">
                                                            <!-- content -->

                                                            <table class="table table-bordered table-condensed">
                                                                <thead class="table-danger">
                                                                    <tr class="align-middle text-center">
                                                                        <th style="width: 75px;"><b>No</b></th>
                                                                        <th><b>Judul Dokumen</b></th>
                                                                        <th><b>Link Dokumen</b></th>
                                                                        <th><b>Deskripsi</b></th>
                                                                        <th><b>Download file</b></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-if="loadingTable.dokumentasiPersepsi == true">
                                                                        <td colspan="30" class="text-center">
                                                                            <i class="fas fa-spin fa-spinner"></i> loading.....
                                                                        </td>
                                                                    </tr>
                                                                    <tr v-else-if="dataTableDokumentasiPersepsi == ''">
                                                                        --- Data Kosong ---
                                                                    </tr>
                                                                    <tr v-else v-for="(rowData, keyData) in dataTableDokumentasiPersepsi" :key="keyData">
                                                                        <td class="text-center">{{ keyData + 1 }}</td>
                                                                        <td>{{ rowData.lm_name }}</td>
                                                                        <td>{{ rowData.lm_link }}</td>
                                                                        <td style="text-align: center;">{{  rowData.lm_description }}</td>
                                                                        <td class="text-center">
                                                                            <b-button variant="primary" size="sm" @click = "downloadFile(rowData.materi_pembelajaran_dokumen.lmd_path_file)">
                                                                                <i class="fas fa-download"></i>
                                                                                &nbsp;
                                                                                <span>Download</span>
                                                                            </b-button>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-tab>
                                        </b-tabs>
                                    </div>
                                </b-card>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </Layout>

    <b-modal v-model="showModal.upload" title="Modal Upload" title-class="text-black font-18" body-class="p-3" size="md" hide-footer>
        <div class="form-group mb-3">
            <label for="">Upload</label>
            <input type="file" class="form-control">
        </div>
    </b-modal>
</template>
